import { apiInstance } from "@/api/instance";

export default async function (params) {
  return apiInstance.post(`/user/email-verification`, null, { params });
}
